import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import style from '../assets/styles/mainMenu.module.scss';
import { GlobalContext } from '../GlobalContext.js';
import { AdminBackdoor } from '../Hooks/useAdminBackdoor.js';

const PedidoButton = React.memo(({ navigate }) => {
  console.log('🎯 PedidoButton renderizado!');

  return (
    <button
      className={style.orderBtn}
      onClick={() => {
        navigate(); // Chamamos a navegação aqui para ver se dispara corretamente
      }}
    >
      VEJA O SEUS PEDIDOS
    </button>
  );
});

const SubHeaderCustomer = ({ logoutCustomer, nameClient, hasTable: propHasTable }) => {
  const globalData = React.useContext(GlobalContext);
  const { isToten, pdvRequest, hasClients } = globalData;

  const navigate = useNavigate();

  const storedTable = typeof window !== 'undefined' ? localStorage.getItem('tableNumber') : null;
  const hasTable = propHasTable !== undefined
    ? Boolean(propHasTable)
    : Boolean(storedTable && storedTable !== 'null' && storedTable !== 'undefined' && storedTable.trim() !== '');

  const handleNavigate = React.useCallback(() => {
    console.log('🚀 Navegação acionada!');
    if (!pdvRequest) {
      navigate('/request');
    }
  }, [navigate]);

  return (
    <div
      className={`${style.containerBtn} ${isToten ? style.toten : ''}`}
    >
      <section className={isToten ? style.headerToten : ''}>
        {!isToten && (
          <div>
            <p onClick={!hasClients ? null : logoutCustomer}>
              Bem vindo {nameClient && <span>{nameClient}</span>}
            </p>
          </div>
        )}
        {/* <button onClick={() => setTimeout(() => navigate('/request'), 1000)}>
          Seus Pedidos
        </button> */}

        <PedidoButton navigate={handleNavigate} />

        {!isToten && (
          <div className={style.queuePlaceholder} aria-hidden="true" />
        )}

        {isToten && <AdminBackdoor style={{ opacity: 0, display: 'block', width: '50px', height: '50px' }} />}
      </section>
    </div>
  );
};
export default SubHeaderCustomer;
